<template>
  <div>
    <AppHeader />
    <HeroSection />
    <AboutSection />
    <ServicesSection />
    <ReferencesSection />
    <ContactSection />
    <AppFooter />
    <RenameNotice />
    <CookieConsent />
    <CookieNotice />
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, watch } from 'vue'
import { LOCALES, PRIMARY_LOCALE, buildHreflangAlternatives } from '~/composables/useI18n'

const { locale, messages: m, localeUrl } = useI18n()

const OG_LOCALES = {
  hu: 'hu_HU',
  en: 'en_US',
  de: 'de_DE'
} as const

useHead(() => {
  const alternateLocales = LOCALES
    .filter((item) => item.code !== locale.value)
    .map((item) => ({ property: 'og:locale:alternate', content: OG_LOCALES[item.code] }))

  const hreflangLinks = buildHreflangAlternatives().map((item) => ({
    rel: 'alternate',
    ...item
  }))

  return {
    htmlAttrs: { lang: locale.value },
    title: m.value.meta.title,
    link: [
      { rel: 'canonical', href: localeUrl.value },
      ...hreflangLinks
    ],
    meta: [
      { name: 'description', content: m.value.meta.description },
      { 'http-equiv': 'content-language', content: locale.value },
      ...(locale.value === PRIMARY_LOCALE
        ? [
            { name: 'geo.region', content: 'HU' },
            { name: 'geo.placename', content: 'Hungary' }
          ]
        : []),
      { property: 'og:title', content: m.value.meta.ogTitle },
      { property: 'og:description', content: m.value.meta.ogDescription },
      { property: 'og:locale', content: m.value.meta.ogLocale },
      { property: 'og:url', content: localeUrl.value },
      ...alternateLocales
    ],
    script: [
      {
        key: 'schema-org',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(buildLocalBusinessSchema(m.value, locale.value, localeUrl.value))
      }
    ]
  }
})

const refreshScrollReveal = async () => {
  await nextTick()
  useScrollReveal()
}

onMounted(async () => {
  await refreshScrollReveal()
  useEmailSuccessToast()
})

watch(locale, refreshScrollReveal)
</script>